import { gql } from "@apollo/client";
import { OrderPage_GetExistingOrderQuery, TransactionType } from "../../../codegen/graphql";
import { verifyOrderDataIntegrity, VerifyOrderDataIntegrity_Order } from "../../../common/verifyOrderDataIntegrity";


export const OrderPageVerifyDataIntegrity_Order = gql`
  fragment OrderPageVerifyDataIntegrity_Order on Order {
    ...VerifyOrderDataIntegrity_Order
  }
  ${VerifyOrderDataIntegrity_Order}
`;

export default function OrderPageVerifyDataIntegrity({
  order,
}: {
  order: NonNullable<OrderPage_GetExistingOrderQuery['order']>
}) {
  
  const results = verifyOrderDataIntegrity(order);
  
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">Data Integrity Check</h1>
      <p className="text-gray-600 mb-4">
        {results.length === 0 
          ? "No issues found. All checks passed." 
          : `${results.length} tests ran on the order:`}
      </p>
      
      {results.length > 0 && (
        <div className="overflow-x-auto">
          <div className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
            {/* Header */}
            <div className="grid grid-cols-[120px_120px_1fr_2fr_1.5fr] gap-4 bg-gray-50 border-b border-gray-200 px-6 py-3">
              <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </div>
              <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                Severity
              </div>
              <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                Title
              </div>
              <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                Description
              </div>
              <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                Debug Info
              </div>
            </div>
            
            {/* Rows */}
            <div className="divide-y divide-gray-200">
              {results.map((result, index) => (
                <div key={index} className="grid grid-cols-[120px_120px_1fr_2fr_1.5fr] gap-4 px-6 py-4 hover:bg-gray-50">
                  <div className="whitespace-nowrap">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      result.result 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {result.result ? '✓ Pass' : '✗ Fail'}
                    </span>
                  </div>
                  <div className="whitespace-nowrap">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium`}>
                      {result.severity === 'error' ? 'Error' : 'Warning'}
                    </span>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-900">
                      {result.title}
                    </div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">
                      {result.description}
                    </div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500">
                      {result.debug && typeof result.debug === 'object' ? (
                        <div className="space-y-1">
                          {Object.entries(result.debug).map(([key, value]) => (
                            <div key={key} className="flex">
                              <span className="font-medium mr-2">{key}:</span>
                              <span>{String(value)}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span>{String(result.debug)}</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}